module.exports = __webpack_public_path__ + "img/wechat-official.44227954.png";